module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('mt-header', {
    attrs: {
      "title": "消息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "messageList"
  }, [_c('div', {
    staticClass: "systemMsg"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.openPopup('', 1, '管理员')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "userMsg"
  }, [_c('ul', _vm._l((_vm.friendsLists), function(friendsList, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.openPopup(friendsList.orderProjectId, friendsList.toUserId, friendsList.toUser)
        }
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": _vm.httpUrl + friendsList.resAddr
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(friendsList.toUser))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(friendsList.orderProjectName))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(friendsList.recentlyTime)))]), _c('span', {
      staticClass: "msgNumber"
    }, [_vm._v(_vm._s(friendsList.unreadCount))])])])
  }), 0)])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('mt-header', {
    attrs: {
      "title": _vm.toUserName
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closePopup($event)
      }
    },
    slot: "left"
  }, [_vm._v("消息")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projectTitle),
      expression: "projectTitle"
    }],
    staticClass: "title"
  }, [_c('div', {
    staticClass: "bgimg",
    class: {
      'zhaomu': _vm.project.status == 4, 'close': _vm.project.status == 5, 'jinxing': _vm.project.status == 7, 'over': _vm.project.status == 8, 'hezuo': _vm.project.status == 6, 'pingjia': _vm.project.status == 9
    }
  }), _vm._v(" "), _c('p', [_vm._v("项目 "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.projectJump(_vm.project.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.project.description))])]), _vm._v(" "), _c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [_c('div', {
    ref: "divmsg",
    staticClass: "talkContent"
  }, _vm._l((_vm.msgHistorys), function(msgHistory, index) {
    return _c('div', {
      key: index,
      class: {
        'sendMsg': msgHistory.fromuser === _vm.currentUser, 'receiveMsg': msgHistory.fromuser !== _vm.currentUser
      }
    }, [_c('p', {
      staticClass: "Msgtime"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(msgHistory.sendtime)))]), _vm._v(" "), (msgHistory.msgtype === 'IMG') ? _c('div', {
      staticClass: "portrait"
    }, [_c('img', {
      attrs: {
        "src": _vm.httpUrl + msgHistory.msg
      }
    })]) : _vm._e(), _vm._v(" "), (msgHistory.msgtype === 'TXT') ? _c('div', {
      staticClass: "msgContent"
    }, [_c('p', [_vm._v(_vm._s(msgHistory.msg))]), _c('span', {
      staticClass: "triangle"
    })]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "inputPart"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendMsg),
      expression: "sendMsg"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sendMsg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendMsg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('icon', {
    attrs: {
      "name": "smile-o"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showEmoji($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "picture-o"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showPicture($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "upDataPart",
    attrs: {
      "id": "upDataPart",
      "type": "file",
      "multiple": "",
      "accept": "image/*",
      "value": "上传",
      "enctype": "multipart/form-data"
    },
    on: {
      "change": function($event) {
        return _vm.onFormChange($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "chevron-right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showMessage($event)
      }
    }
  })], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/img/message/18-1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("云智图 - 小云")]), _vm._v(" "), _c('span', [_vm._v("一大波需求来袭")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7be327e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/message.vue
// module id = 1289
// module chunks = 1